var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-card container-view"},[_c('row-grid',{attrs:{"span":[14, 10]},scopedSlots:_vm._u([{key:"0",fn:function(){return [_c('table-view',{ref:_vm.tlRefName,attrs:{"meta":_vm.tlMeta},on:{"active-change":_vm.handleActiveChange},scopedSlots:_vm._u([{key:"prefix-btn",fn:function(ref){
var conf = ref.conf;
var choseData = ref.choseData;
return [_vm._t("prefix-btn",null,{"conf":conf,"choseData":choseData})]}},{key:"add-btn",fn:function(ref){
var conf = ref.conf;
return [_vm._t("add-btn",null,{"conf":conf})]}},{key:"batch-delete-btn",fn:function(ref){
var conf = ref.conf;
var choseData = ref.choseData;
return [_vm._t("batch-delete-btn",null,{"conf":conf,"choseData":choseData})]}},{key:"suffix-btn",fn:function(ref){
var conf = ref.conf;
var choseData = ref.choseData;
return [_vm._t("suffix-btn",null,{"conf":conf,"choseData":choseData})]}},{key:"buttons",fn:function(ref){
var scope = ref.scope;
var conf = ref.conf;
return [_vm._t("buttons",null,{"conf":conf,"scope":scope})]}}],null,true)})]},proxy:true},{key:"1",fn:function(){return [_c('div',{staticClass:"el-card",staticStyle:{"margin-left":"5px"}},[_c('form-view',{attrs:{"meta":_vm.fmMeta},on:{"ok":_vm.formSubmit},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var model = ref.model;
var conf = ref.conf;
return [_vm._t("action",null,{"model":model,"conf":conf})]}}],null,true)})],1)]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }